<template>
    <b-modal size="xl" hide-footer title="Manage CCB Admin USers" id="ccbAdminUsersModal">
        <div class="modal-body">
            <b-tabs nav-class="nav-tabs-custom" content-class="p-3 text-muted">
                <b-tab active>
                    <template v-slot:title>
                        <span class="d-none d-sm-inline-block">Form</span>
                    </template>
                    <b-form class="usersForm" v-if="show_form">
                        <b-row>
                            <b-col cols="6">
                                <b-form-group id="name" label="Name" label-for="name-input">
                                    <b-form-input id="name-input" v-model="form.name" type="text" placeholder="Enter name" required></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col cols="6">
                                <b-form-group id="email" label="Email" label-for="email-input">
                                    <b-form-input id="email-input" v-model="form.email" type="email" placeholder="Enter email" required></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                <!-- --------------------- -->
                        <b-row>
                            <b-col cols="4">
                                <b-form-group id="cell_no" label="Cell No" label-for="number-input">
                                    <b-form-input id="number-input" v-model="form.cell_no" type="number" placeholder="Enter cell number" required></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col cols="4">
                                <b-form-group id="id_number" label="ID Number" label-for="id-input">
                                    <b-form-input id="id-input" v-model="form.id_number" type="number" placeholder="ID number" required></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col cols="4">
                                <b-form-group id="years_experience" label="Years Experience" label-for="years_experience-input">
                                    <b-form-input id="years_experience-input" v-model="form.years_experience" type="number" placeholder="Enter years of experience" required></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                <!-- --------------------- -->
                        <b-row>
                            <b-col cols="12">
                                <b-form-group id="academic_qualifications" label="Academic Qualifications" label-for="academic_qualifications-input">
                                    <b-form-textarea id="academic_qualifications-input" v-model="form.academic_qualifications" type="phone" placeholder="Enter academic qualifications" required></b-form-textarea>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <!--<b-row>
                            <b-col cols="12">
                                <b-form-group id="designation" label="Designation" label-for="designation-input">
                                    <b-form-textarea id="designation-input" v-model="form.designation" type="text" placeholder="Designation description" required></b-form-textarea>
                                </b-form-group>
                            </b-col>
                        </b-row>-->

                        <b-row>
                            <b-col cols="12">
                                <b-form-group id="work_qualifications" label="Work Qualifications" label-for="work_qualifications-input">
                                    <b-form-textarea id="work_qualifications-input" v-model="form.work_qualifications" type="text" placeholder="Enter work qualifications" required></b-form-textarea>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <hr>

                        <b-row>
                            <b-col cols="6">
                                <b-form-group id="password" :label="passwordLable" label-for="password-input">
                                    <b-form-input id="password-input" v-model="form.password" type="password" placeholder="Password" :required="is_new_user"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-tab>
            </b-tabs>
        </div>
        <div class="w-100 mt-2 mb-2" >
            <b-button style="float: right;" variant="success" @click="save()">Save</b-button>
            <b-button class="me-2" style="float: right;" @click="$bvModal.hide('ccbAdminUsersModal')">Cancel</b-button>
        </div>
        <b-overlay :show="is_loading" no-wrap></b-overlay>
    </b-modal>
</template>

<script>
import _ from 'lodash'
//import FileUpload from './fileUpload.vue'
import { ccbAdminState, ccbAdminMethods } from '@/state/helpers'
export default {
    props:{
        user_data:{
            default: {},
        },
    },
    watch:{
        user_data(newValue){
            if(newValue != null){
                this.form = _.cloneDeep(this.user_data);
                this.is_new_user = false;
            }
        }
    },
    components:{
        //FileUpload,
    },
    data:() => ({
        is_loading: false,
        is_new_user: false,
        show_form: false,
        form:{},
    }),
    computed:{
        ...ccbAdminState,
        user_id(){
            if(this.form.id != undefined){
                return this.form.id;
            }
            else{
                return -1;
            }
        },
        passwordLable(){
            if(this.is_new_user){
                return 'User Password'
            }
            else{
                return 'Update Password'
            }
        }
    },
    methods:{
        ...ccbAdminMethods,
        save(){
            this.is_loading = true;
            let params = this.processParams();
            if(this.is_new_user){
                params.level_id = this.selected_level_id;
                params.password = this.form.password,
                this.saveAdminUser(params)
                .then(()=>{
                    this.loadAdminUsers()
                    .then(()=>{
                        this.is_loading = false;
                        this.$bvModal.hide('ccbAdminUsersModal');
                    })
                })
                /*.then((response)=>{
                    this.loadLevelUsers(this.selected_level_id)
                    .then(()=>{
                        this.is_loading = false;
                        this.$emit('selectNewUser', response.id)
                    })
                    
                })*/
            }
            else{
                if(this.form.password != ''){
                    params.password = this.form.password;
                }
                this.saveAdminUser(params)
                .then(()=>{
                    this.loadAdminUsers()
                    .then(()=>{
                        this.is_loading = false;
                        this.$bvModal.hide('ccbAdminUsersModal');
                    })
                    /*this.loadLevelUsers(this.selected_level_id)
                    .then(()=>{
                        this.is_loading = false;
                        this.$bvModal.hide('ccbAdminUsersModal')
                    })*/
                })
            }
        },
        downloadFile(type){
            let params = {
                type: type,
                jwt: window.localStorage.getItem('x_token'),
                user_id: this.form.id,
            };
            this.downloadPersonnelDocument(params)
            .then( response => {
                console.log('RESPONSE: ', response);
            })
        },
        processParams(){
            let data = {
                id: this.form.id,
                name: this.form.name,
                cell_no: this.form.cell_no,
                email: this.form.email,
                designation: this.form.designation,
                id_number: this.form.id_number,
                academic_qual: this.form.academic_qualifications,
                work_qual: this.form.work_qualifications,
                years_experience: this.form.years_experience,
            }
            return data;
        }
    },
    mounted(){
        if(this.user_data == null){
            this.form = {
                id: -1,
                level_id: '',
                name: '',
                cell_no: '',
                email: '',
                designation: '',
                id_number: '',
                academic_qualifications: '',
                work_qualifications: '',
                years_experience: '',
                id_copy_s3_src: '',
                job_desc_s3_src: '',
                letter_of_acceptance_s3_src: '',
                letter_of_appointment_s3_src: '',
                police_clearance_s3_src: '',
                password: '',
            };
            this.is_new_user = true;
            this.show_form = true;
        }
        else{
            this.form = _.cloneDeep(this.user_data);
            this.$nextTick(()=>{
                this.show_form = true;
            })
        }
    },
}
</script>

<style>
    .usersForm > .row{
        padding-bottom: 0.9rem;
    }

    .accordion > div{
        padding-bottom: 0.8rem;
    }
</style>